import { useLocation, useNavigate } from "react-router-dom";
import { RolesEnum } from "../../../enums/roles";
import { TipoClienteEnum } from "../../../enums/tipoCliente";
import { useSessionStorage } from "../../../hooks/useSessionStorage";
import { useUserPermissions } from "../../../hooks/useUserPermissions";
import { getEmpresa } from "../../../utils/getEmpresa";
import { useAgendamentoStepIndicator } from "../../../hooks/useAgendamentoStepIndicator";
import { isAgendamentoLotePath } from "../../../hooks/useAgendamentoStepIndicator/agendamentoV2Steps";

export const useHomeV2 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [token] = useSessionStorage("@token");
  const { hasRole, isUserType } = useUserPermissions();
  const stepIndicator = useAgendamentoStepIndicator("hidden md:flex");

  const isCliente = hasRole(RolesEnum.ROLE_CLIENTE);
  const isDespachante = isUserType(TipoClienteEnum.DESPACHANTE);
  const isLoteFlow = isAgendamentoLotePath(location.pathname);
  const mostrarItinerante = Boolean(token) && isDespachante;
  const empresa = getEmpresa(process.env.REACT_APP_PROJECT as string);

  const destinoLoja =
    isLoteFlow && isDespachante
      ? "/agendamento-lote/loja"
      : isCliente
        ? "/agendamento/loja"
        : "/novo-agendamento";
  const destinoDomicilio =
    isLoteFlow && isDespachante
      ? "/agendamento-lote/delivery"
      : isCliente
        ? "/agendamento/domicilio"
        : "/novo-agendamento";
  const destinoItinerante =
    isLoteFlow && isDespachante
      ? "/agendamento-lote/itinerantes"
      : "/agendamento/itinerantes";

  const handleLoja = () => navigate(destinoLoja);
  const handleDomicilio = () => navigate(destinoDomicilio);
  const handleItinerante = () => navigate(destinoItinerante);

  return {
    empresa,
    mostrarItinerante,
    handleLoja,
    handleDomicilio,
    handleItinerante,
    stepIndicator,
  };
};
